const TYP_COLORS = {
    MAT:  { bg: 'rgba(245,158,11,0.15)', color: '#F59E0B', border: 'rgba(245,158,11,0.3)', label: 'MAT' },
    SEM:  { bg: 'rgba(168,85,247,0.15)',  color: '#A855F7', border: 'rgba(168,85,247,0.3)', label: 'SEM' },
    OBA:  { bg: 'rgba(16,185,129,0.15)',  color: '#10B981', border: 'rgba(16,185,129,0.3)', label: 'OBA' },
    SPOZ: { bg: 'rgba(234,179,8,0.15)',   color: '#EAB308', border: 'rgba(234,179,8,0.3)',  label: 'SPOZ' },
    PRO:  { bg: 'rgba(6,182,212,0.15)',   color: '#06B6D4', border: 'rgba(6,182,212,0.3)',  label: 'PRO' },
    ADD:  { bg: 'rgba(236,72,153,0.15)',  color: '#EC4899', border: 'rgba(236,72,153,0.3)', label: 'ADD' },
};

export default function TypBadge({ typ }) {
    const c = TYP_COLORS[typ] || TYP_COLORS.MAT;
    return (
        <span style={{
            display: 'inline-flex', alignItems: 'center',
            padding: '1px 6px', borderRadius: 999,
            fontSize: 10, fontWeight: 600,
            background: c.bg, color: c.color,
            border: `1px solid ${c.border}`,
            whiteSpace: 'nowrap', lineHeight: '16px',
        }}>
            {c.label}
        </span>
    );
}

export { TYP_COLORS };
